import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface BestSeller {
  id: number;
  name: string;
  sum: number;
}
export interface SummarySeller {
  sum_amount: number;
  best_seller: BestSeller[];
}

export interface SummaryDaily {
  date: Date,
  sum: number
}
@Injectable({
  providedIn: 'root'
})

export class SummaryService {
  private API_SUMMARY = "/api/summary"
  constructor(private httpClient: HttpClient) { }

  getBestseller(start: string, end: string) {
    let part = `${this.API_SUMMARY}/bastseller?start=${start}&end=${end}`
    return this.httpClient.get<SummarySeller>(part)
  }
  getDailySeller(start: string, end: string | null) {
    let part = `${this.API_SUMMARY}/daily?start=${start}&end=${end}`
    return this.httpClient.get<SummaryDaily[]>(part)
  }

  getProductSellerToday(start: string, end: string | null) {
    let part = `${this.API_SUMMARY}/on-daily?start=${start}&end=${end}`
    return this.httpClient.get<SummarySeller>(part)
  }
}
